import { useNavigate } from 'react-router-dom';
import Logo from '../../images/Logo';
import styles from './LandingBase.module.css';

const scrollTo = (id: string) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

const Footer = ({ esconder = false }) => {
  const navigate = useNavigate();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <div className={styles.footerTop}>
          <div className={styles.brand} onClick={() => scrollTo('principal')}>
            <Logo className={styles.brandIcon} />
            <span>Finant</span>
          </div>
          {!esconder && (
            <div className={styles.footerLinks}>
              <span className={styles.footerLink} onClick={() => scrollTo('funcionalidades')}>
                Funcionalidades
              </span>
              <span className={styles.footerLink} onClick={() => scrollTo('como')}>
                Como funciona
              </span>
              <span className={styles.footerLink} onClick={() => scrollTo('perguntas')}>
                Perguntas
              </span>
              <span className={styles.footerLink} onClick={() => navigate('/termos-e-politicas')}>
                Termos e Políticas
              </span>
            </div>
          )}
        </div>
        <span className={styles.footerDivider} />
        <span className={styles.footerCopy}>© {new Date().getFullYear()} Finant. Suas finanças organizadas, sem planilha.</span>
      </div>
    </footer>
  );
};

export default Footer;
